module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tao-main",
    on: {
      "click": function($event) {
        _vm.gotoDetail(_vm.item, _vm.types, _vm.idx)
      }
    }
  }, [_c('div', {
    staticClass: "tao-left"
  }, [_c('img', {
    attrs: {
      "src": _vm.item.Pic
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tao-right"
  }, [_c('div', {
    staticClass: "tao-right-head"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("limitStr")(_vm.item.D_title, 7)))])]), _vm._v(" "), _c('div', {
    staticClass: "tao-right-body"
  }, [_c('img', {
    attrs: {
      "src": _vm.img
    }
  }), _vm._v("\n      ¥\n      "), _c('span', {
    staticClass: "tao-right-price"
  }, [_vm._v("\n        " + _vm._s(_vm._f("subPrice")(_vm.item.Price, 1)) + "\n      ")]), _vm._v(" "), (_vm.isShowQuan) ? _c('span', {
    staticClass: "tao-right-price-desc"
  }, [_vm._v("券后价")]) : _c('span', {
    staticClass: "tao-right-price-desc"
  }, [_vm._v("优惠价")])]), _vm._v(" "), _c('div', {
    staticClass: "tao-right-foot",
    attrs: {
      "ng-show": "isShowQuan"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm._f("subPrice")(_vm.item.Quan_price)) + "元券")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1014cb2d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/wxShare/Tao.vue
// module id = 197
// module chunks = 2